<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true">{{dataItem | property: label}}</span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-sellable-size-single-select-edit-control #editControl (focussed)="columnFocusHandler($event, columnIndex)" [elementId]="elementId"
                                                  [sizeGroupId]="sizeGroupIdField"
                                                  [formControl]="formGroup.get(valueField)"
                                                  [placeholder]="getPlaceholder(dataItem)"
                                                  [objectValue]="formGroup.get(field)">
    </wbo-sellable-size-single-select-edit-control>
</ng-template>
